import { render, staticRenderFns } from "./SidebarNav.vue?vue&type=template&id=22892f09&scoped=true&lang=pug"
import script from "./SidebarNav.vue?vue&type=script&lang=js"
export * from "./SidebarNav.vue?vue&type=script&lang=js"
import style0 from "./SidebarNav.vue?vue&type=style&index=0&id=22892f09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22892f09",
  null
  
)

export default component.exports